// constants.ts

export const DEFAULT_HEADERS = {}
